import React, { useState, useEffect } from "react";
import Header from "../../components/header";
import History from "../../components/history";
import styles from "./InventarioFinal.module.css";
import { Table, Row, Col, Form, Button } from "react-bootstrap";
import { useCookies } from "react-cookie";
import Notifications, { notify } from "react-notify-toast";
import { NumericFormat } from "react-number-format";
import { format } from "../../core/number";
import axios from "axios";

const InventarioFinal = (props) => {
  const { embedded = false, year: propYear } = props;
  const [cookie] = useCookies(["kUserSession"]);
  const [loading, setLoading] = useState(false);
  const [inventory, setInventory] = useState([]);
  const [year, setYear] = useState(propYear ?? new Date().getFullYear());
  const [preview, setPreview] = useState([]);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [periodOpen, setPeriodOpen] = useState(false);
  const [snapshotId, setSnapshotId] = useState(null);
  const defaultSummary = {
    totalKg: 0,
    totalKgAnterior: 0,
    kilosPromedioAnio: 0,
    ugPromedioAnio: 0,
    totalHa: 0,
    kilosProducidos: 0,
    totalHaLimpiasPeriodo: 0,
  };
  const [summary, setSummary] = useState(defaultSummary);

  const history = [
    { name: "Inicio", path: "/" },
    { name: "Movimientos de hacienda", path: "/movimientos" },
  ];

  const prepareHeaders = () => {
    return {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        api_key: "k-randa",
        access_token: cookie.kUserSession.data.access_token,
      },
    };
  };

  const retrievePreview = () => {
    setLoadingPreview(true);
    const currentFarm = cookie.kUserSession.data["farm"];
    const url =
      "inventario_snapshot/preview/final?id_estancia=" +
      currentFarm.id +
      "&anho=" + year;
    axios
      .get(process.env.REACT_APP_API_URL + url, prepareHeaders())
      .then((rs) => {
        if (rs.status === 200) {
          const data = rs.data;
          setPreview(data.items || []);
          setSummary({
            totalKg: data.totalKg || 0,
            totalKgAnterior: data.totalKgAnterior || 0,
            kilosPromedioAnio: data.kilosPromedioAnio || 0,
            ugPromedioAnio: data.ugPromedioAnio || 0,
            kilosProducidos: data.kilosProducidos || 0,
            totalHa: data.totalHa || 0,
            totalHaLimpiasPeriodo: data.totalHaLimpiasPeriodo || 0,
          });
        } else {
          setPreview([]);
          setSummary(defaultSummary);
        }
        setLoadingPreview(false);
      })
      .catch((err) => {
        console.error(err);
        setPreview([]);
        setSummary(defaultSummary);
        setLoadingPreview(false);
      });
  };

  const retrievePeriodo = () => {
    const currentFarm = cookie.kUserSession.data["farm"];
    const url = `periodos/${year}/${currentFarm.id}`;
    axios
      .get(process.env.REACT_APP_API_URL + url, prepareHeaders())
      .then((rs) => {
        if (rs.status === 200) {
          setPeriodOpen(rs.data?.estado === "ABIERTO");
        } else {
          setPeriodOpen(false);
        }
      })
      .catch(() => setPeriodOpen(false));
  };

  const handleChange = (idx, field, value) => {
    setPreview((prev) => {
      const data = [...prev];
      const item = { ...data[idx] };
      if (field === "pesoProm") {
        const total =
          parseFloat(value || 0) * (item.existencia || item.cantidad || 0);
        item.pesoTotal = total;
        item.peso_total = total;
      } else if (field === "pesoTotal") {
        const total = parseFloat(value || 0);
        item.pesoTotal = total;
        item.peso_total = total;
      }
      data[idx] = item;
      const totalKg = data.reduce(
        (acc, cur) => acc + (parseFloat(cur.pesoTotal || cur.peso_total || 0)),
        0
      );
      setSummary((prev) => ({ ...prev, totalKg }));
      return data;
    });
  };

  const handleSummaryChange = (field, value) => {
    setSummary((prev) => ({ ...prev, [field]: value || 0 }));
  };

  const confirmSnapshot = () => {
    setConfirmLoading(true);
    const currentFarm = cookie.kUserSession.data["farm"];
    const body = {
      data: {
        anho: year,
        idEstancia: currentFarm.id,
        tipo: "FINAL",
        totalKg: summary.totalKg,
        totalKgAnterior: summary.totalKgAnterior,
        kilosPromedioAnio: summary.kilosPromedioAnio,
        kilosProducidos: summary.kilosProducidos,
        ugPromedioAnio: summary.ugPromedioAnio,
        totalHa: summary.totalHa,
        totalHaLimpiasPeriodo: summary.totalHaLimpiasPeriodo,
        items: preview.map((i) => ({
          categoriaId: i.idCategoria,
          carimbo: i.carimbo,
          cantidad: i.existencia,
          pesoTotal: i.pesoTotal,
          pesoPromedio: i.pesoTotal / i.existencia
        })),
      },
    };
    if (snapshotId) {
      body.data.snapshotId = snapshotId;
    }
    const url = "inventario_snapshot";
    const request = snapshotId
      ? axios.put(
          process.env.REACT_APP_API_URL + url,
          body,
          prepareHeaders()
        )
      : axios.post(
          process.env.REACT_APP_API_URL + url,
          body,
          prepareHeaders()
        );
    request
      .then(() => {
        setConfirmLoading(false);
        notify.show("Inventario final confirmado", "success");
        retrieve();
      })
      .catch((err) => {
        console.error(err);
        setConfirmLoading(false);
        notify.show("Ocurrió un error al confirmar", "error");
      });
  };

  const edit = () => {
    setPreview(
      inventory.map((i) => ({
        nombre: i.categoria?.nombre,
        idCategoria: i.categoria?.idCategoria,
        carimbo: i.carimbo,
        existencia: i.cantidad,
        pesoTotal: i.pesoTotal ?? i.peso_total,
      }))
    );
    setInventory([]);
  };

  const cancelEdit = () => {
    setPreview([]);
    retrieve();
    setConfirmLoading(false);
  };

  const retrieve = () => {
    setLoading(true);
    const currentFarm = cookie.kUserSession.data["farm"];
    const url =
      "inventario_snapshot?tipo=FINAL&id_estancia=" +
      currentFarm.id +
      "&anho=" + year;
    axios
      .get(process.env.REACT_APP_API_URL + url, prepareHeaders())
      .then((rs) => {
        if (rs.status === 200 && rs.data && rs.data.data) {
          const data = rs.data.data;
          if (data.items && data.items.length > 0) {
            setInventory(data.items);
            setPreview([]);
            setSnapshotId(data.id);
          } else {
            setInventory([]);
            setSnapshotId(null);
            retrievePreview();
          }
          setSummary({
            totalKg: data.totalKg || 0,
            totalKgAnterior: data.totalKgAnterior || 0,
            kilosPromedioAnio: data.kilosPromedioAnio || 0,
            ugPromedioAnio: data.ugPromedioAnio || 0,
            kilosProducidos: data.kilosProducidos || 0,
            totalHa: data.totalHa || 0,
            totalHaLimpiasPeriodo: data.totalHaLimpiasPeriodo || 0,
          });
        } else {
          setInventory([]);
          setSnapshotId(null);
          retrievePreview();
          setSummary(defaultSummary);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setInventory([]);
        setSnapshotId(null);
        setLoading(false);
        setSummary(defaultSummary);
        retrievePreview();
      });
  };

  const deleteSnapshot = () => {
    if (!snapshotId) return;
    axios
      .delete(
        process.env.REACT_APP_API_URL + `inventario_snapshot/${snapshotId}`,
        prepareHeaders()
      )
      .then(() => {
        notify.show("Inventario eliminado", "success");
        setInventory([]);
        setSnapshotId(null);
        retrievePreview();
      })
      .catch((err) => {
        console.error(err);
        notify.show("Ocurrió un error al eliminar", "error");
      });
  };

  useEffect(() => {
    retrieve();
    retrievePeriodo();
  }, []);

  useEffect(() => {
    if (propYear !== undefined) {
      setYear(propYear);
    }
  }, [propYear]);

  useEffect(() => {
    retrieve();
    retrievePeriodo();
  }, [year]);

  const previewTotals = preview.reduce(
    (acc, cur) => ({
      cantidad: acc.cantidad + (parseFloat(cur.existencia || cur.cantidad) || 0),
      peso:
        acc.peso + (parseFloat(cur.pesoTotal || cur.peso_total) || 0),
    }),
    { cantidad: 0, peso: 0 }
  );
  const previewPromedio =
    preview.length > 0
      ? preview.reduce((acc, cur) => {
          const cantidad = parseFloat(cur.existencia || cur.cantidad) || 0;
          const peso = parseFloat(cur.pesoTotal || cur.peso_total) || 0;
          return acc + (cantidad > 0 ? peso / cantidad : 0);
        }, 0) / preview.length
      : 0;

  const inventoryTotals = inventory.reduce(
    (acc, cur) => ({
      cantidad: acc.cantidad + (parseFloat(cur.cantidad) || 0),
      peso:
        acc.peso + (parseFloat(cur.pesoTotal || cur.peso_total) || 0),
    }),
    { cantidad: 0, peso: 0 }
  );
  const inventoryPromedio =
    inventory.length > 0
      ? inventory.reduce((acc, cur) => {
          const cantidad = parseFloat(cur.cantidad) || 0;
          const peso = parseFloat(cur.pesoTotal || cur.peso_total) || 0;
          return acc + (cantidad > 0 ? peso / cantidad : 0);
        }, 0) / inventory.length
      : 0;

  return (
    <>
      <Notifications />
      {!embedded && <Header history={props.history} />}
      <section className={styles.body}>
        {!embedded && (
          <Row>
            <Col>
              <History
                items={history}
                current={"Inventario final"}
                history={props.history}
              />
            </Col>
          </Row>
        )}
        <Row>
          {!embedded && (
            <Col md={2} xs={12}>
              <section className={styles.side}>
                <Form className={styles.searchForm}>
                  <Form.Group>
                    <Form.Label htmlFor="periodo" className={styles.label}>
                      Periodo
                    </Form.Label>
                    <Form.Control
                      id="periodo"
                      className="karanda-input"
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                      type="number"
                    />
                  </Form.Group>
                </Form>
              </section>
            </Col>
          )}
          <Col>
            <section className={styles.content}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "1rem",
                  alignItems: "center",
                }}
              >
                <h1 className={styles.title}>
                  Inventario final periodo {year - 1}/{year}
                </h1>
                {snapshotId && periodOpen && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={deleteSnapshot}
                  >
                    Eliminar
                  </Button>
                )}
              </div>
              <Row>
                <Col md={8} xs={12}>
                  {loading ? (
                    <span>Cargando...</span>
                  ) : inventory.length === 0 ? (
                    loadingPreview ? (
                      <span>Cargando...</span>
                    ) : preview.length > 0 ? (
                      <>
                        <Table bordered hover responsive className="karanda-table">
                          <thead>
                            <tr>
                              <th>Categoría</th>
                              <th>Cantidad</th>
                              <th>Peso prom.</th>
                              <th>Peso total</th>
                            </tr>
                    </thead>
                    <tbody>
                            {preview.map((i, idx) => (
                              <tr key={idx}>
                                <td>{i.nombre + (i.carimbo ? ' CO' + i.carimbo : '')}</td>
                                <td>{i.existencia}</td>
                                <td>
                                  <NumericFormat
                                    className="karanda-input karanda-input-small"
                                    style={{ textAlign: "right" }}
                                    value={i.pesoTotal / i.existencia}
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator="," 
                                    decimalScale={2}
                                    allowNegative={false}
                                    onValueChange={(v) =>
                                      handleChange(idx, "pesoProm", v.floatValue)
                                    }
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    className="karanda-input karanda-input-small"
                                    style={{ textAlign: "right" }}
                                    value={i.pesoTotal}
                                    customInput={Form.Control}
                                    thousandSeparator="."
                                    decimalSeparator="," 
                                    decimalScale={2}
                                    allowNegative={false}
                                    onValueChange={(v) =>
                                      handleChange(idx, "pesoTotal", v.floatValue)
                                    }
                                  />
                                </td>
                              </tr>
                            ))}
                            <tr style={{ fontWeight: "bold" }}>
                              <td>Total</td>
                              <td>{previewTotals.cantidad}</td>
                              <td>{format(previewPromedio, 2)}</td>
                              <td>{format(previewTotals.peso, 2)}</td>
                            </tr>
                          </tbody>
                        </Table>
                        <div style={{ textAlign: "right", marginTop: "15px" }}>
                          <Button
                            className="karanda-btn"
                            onClick={confirmSnapshot}
                            disabled={confirmLoading}
                          >
                            {confirmLoading ? (
                              <span>Cargando...</span>
                            ) : (
                              <span>Confirmar</span>
                            )}
                          </Button>
                          <Button
                            className="karanda-btn-outline"
                            onClick={cancelEdit}
                            disabled={confirmLoading}
                            style={{ marginLeft: "10px" }}
                          >
                            Cancelar
                          </Button>
                        </div>
                      </>
                    ) : (
                      <span>No hay registros</span>
                    )
                  ) : (
                    <>
                      <Table
                        bordered
                        hover
                        responsive
                        className="karanda-table"
                      >
                        <thead>
                          <tr>
                            <th>Categoría</th>
                            <th>Cantidad</th>
                            <th>Peso prom.</th>
                            <th>Peso total</th>
                          </tr>
                        </thead>
                      <tbody>
                          {inventory.map((i, idx) => (
                            <tr key={idx}>
                              <td>{i.categoria?.nombre + (i.carimbo ? ' CO' + i.carimbo : '')}</td>
                              <td>{i.cantidad}</td>
                              <td>{format(i.pesoTotal / i.cantidad, 2)}</td>
                              <td>{format(i.pesoTotal, 2)}</td>
                            </tr>
                          ))}
                          <tr style={{ fontWeight: "bold" }}>
                            <td>TOTAL</td>
                            <td>{inventoryTotals.cantidad}</td>
                            <td>{format(inventoryPromedio, 2)}</td>
                            <td>{format(inventoryTotals.peso, 2)}</td>
                          </tr>
                        </tbody>
                      </Table>
                      {periodOpen && (
                        <div style={{ textAlign: "right", marginTop: "15px" }}>
                          <Button className="karanda-btn" onClick={edit}>
                            Editar
                          </Button>
                        </div>
                      )}
                    </>
                  )}
                </Col>
                <Col md={4} xs={12}>
                  <Table bordered hover responsive className="karanda-table">
                    <thead>
                      <tr>
                        <th>Indicador</th>
                        <th>Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>TOTAL KG</td>
                        <td style={{ textAlign: "right" }}>
                          {inventory.length > 0 ? (
                            format(summary.totalKg, 2)
                          ) : (
                            <NumericFormat
                              className="karanda-input karanda-input-small"
                              style={{ textAlign: "right" }}
                              value={summary.totalKg}
                              customInput={Form.Control}
                              thousandSeparator="."
                              decimalSeparator=","
                              decimalScale={2}
                              allowNegative={false}
                              onValueChange={(v) =>
                                handleSummaryChange("totalKg", v.floatValue)
                              }
                            />
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>KILOS PRODUCIDOS</td>
                        <td style={{ textAlign: "right" }}>
                          {inventory.length > 0 ? (
                            format(summary.kilosProducidos, 2)
                          ) : (
                            <NumericFormat
                              className="karanda-input karanda-input-small"
                              style={{ textAlign: "right" }}
                              value={summary.kilosProducidos}
                              customInput={Form.Control}
                              thousandSeparator="."
                              decimalSeparator=","
                              decimalScale={2}
                              allowNegative={false}
                              onValueChange={(v) =>
                                handleSummaryChange("kilosProducidos", v.floatValue)
                              }
                            />
                          )}
                        </td>
                      </tr>                      
                      <tr>
                        <td>KILOS PROMEDIO AÑO</td>
                        <td style={{ textAlign: "right" }}>
                          {inventory.length > 0 ? (
                            format(summary.kilosPromedioAnio, 2)
                          ) : (
                            <NumericFormat
                              className="karanda-input karanda-input-small"
                              style={{ textAlign: "right" }}
                              value={summary.kilosPromedioAnio}
                              customInput={Form.Control}
                              thousandSeparator="."
                              decimalSeparator=","
                              decimalScale={2}
                              allowNegative={false}
                              onValueChange={(v) =>
                                handleSummaryChange("kilosPromedioAnio", v.floatValue)
                              }
                            />
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>UG PROM/AÑO</td>
                        <td style={{ textAlign: "right" }}>
                          {inventory.length > 0 ? (
                            format(summary.ugPromedioAnio, 2)
                          ) : (
                            <NumericFormat
                              className="karanda-input karanda-input-small"
                              style={{ textAlign: "right" }}
                              value={summary.ugPromedioAnio}
                              customInput={Form.Control}
                              thousandSeparator="."
                              decimalSeparator=","
                              decimalScale={2}
                              allowNegative={false}
                              onValueChange={(v) =>
                                handleSummaryChange("ugPromedioAnio", v.floatValue)
                              }
                            />
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>TOTAL HA.</td>
                        <td style={{ textAlign: "right" }}>
                          {inventory.length > 0 ? (
                            format(summary.totalHa, 2)
                          ) : (
                            <NumericFormat
                              className="karanda-input karanda-input-small"
                              style={{ textAlign: "right" }}
                              value={summary.totalHa}
                              customInput={Form.Control}
                              thousandSeparator="."
                              decimalSeparator=","
                              decimalScale={2}
                              allowNegative={false}
                              onValueChange={(v) =>
                                handleSummaryChange("totalHa", v.floatValue)
                              }
                            />
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>TOTAL HA. LIMPIADAS EN EL PERIODO</td>
                        <td style={{ textAlign: "right" }}>
                          {inventory.length > 0 ? (
                            format(summary.totalHaLimpiasPeriodo, 2)
                          ) : (
                            <NumericFormat
                              className="karanda-input karanda-input-small"
                              style={{ textAlign: "right" }}
                              value={summary.totalHaLimpiasPeriodo}
                              customInput={Form.Control}
                              thousandSeparator="."
                              decimalSeparator=","
                              decimalScale={2}
                              allowNegative={false}
                              onValueChange={(v) =>
                                handleSummaryChange("totalHaLimpiasPeriodo", v.floatValue)
                              }
                            />
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
              <Row>
                
              </Row>
            </section>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default InventarioFinal;
